import { render } from "./login_AS.vue?vue&type=template&id=24db72b6&scoped=true"
import script from "./login_AS.vue?vue&type=script&lang=js"
export * from "./login_AS.vue?vue&type=script&lang=js"

import "./login_AS.vue?vue&type=style&index=0&id=24db72b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24db72b6"]])

export default __exports__